import { Linear, ProgramPlaceholder } from '../../entities';

const PROGRAM_DURATION_MIN = 45 * 60 * 1000; // 45 min
const PROGRAM_DURATION_MAX = 75 * 60 * 1000; // 75 min

export const generateEmptyProgramForDay = (
  startTimestamp: number,
  endTimestamp: number,
  linear: Linear,
): ProgramPlaceholder[] => {
  let startTimestampProgram = startTimestamp;
  const programs: ProgramPlaceholder[] = [];
  while (startTimestampProgram < endTimestamp) {
    const endTimestampProgram = Math.min(
      PROGRAM_DURATION_MIN +
        Math.floor((PROGRAM_DURATION_MAX - PROGRAM_DURATION_MIN) * Math.random()) +
        startTimestampProgram,
      endTimestamp,
    );
    const program = new ProgramPlaceholder({
      id: startTimestampProgram,
      endDate: endTimestampProgram,
      linearAssetId: linear.id,
      startDate: startTimestampProgram,
    });

    programs.push(program);
    startTimestampProgram = endTimestampProgram;
  }
  return programs;
};
